// English strings of the cutaway panel (decision D13: English first). Another
// language adds a file next to this one with the same shape.

export const strings = {
  title: "Cutaway",
  intro: "Each plane cuts the engine open. What lies beyond every plane is taken away.",
  none: "No cut: the whole engine shows.",
  side: "Cut away",
  offset: "Offset",
  offsetUnit: "mm",
  offsetHint: "How far the plane sits from the engine's origin, along its direction.",
  add: "Add plane",
  remove: "Remove",
  removeLabel: (n: number) => `Remove plane ${n}`,
  clear: "Clear",
  plane: (n: number) => `Plane ${n}`,
  full: (max: number) => `At most ${max} planes.`,
  sides: {
    top: "Top (+Y)",
    bottom: "Bottom (−Y)",
    left: "Left (+X)",
    right: "Right (−X)",
    front: "Front (+Z)",
    rear: "Rear (−Z)",
    custom: "Custom direction",
  },
};
